import React from 'react';
import './index.scss';

const widthGovRegulat = {
  width: '160px',
  height: '45px'
}

const Footer: React.FC = () => {
  return (
    <>
      <div></div>
      <footer>
        <img src="/images/logo-sutec.png"/>
        <img src="/images/logo-govern-regulat.png" style={widthGovRegulat}/>
        <img src="/images/logo-antt.png"/> 
      </footer>
    </>
  );
};
export default Footer;
